import gql from 'graphql-tag';

// Tenant isolation: ID-based lookup — no org filter at query level.
// Caller: Library detail page (ID extracted from URL, originally navigated from org-scoped list).
// Backend resolvers are responsible for enforcing org-level authorization on direct ID access.
const GET_ORG_MEDIA = gql`
  query orgMedia($mediaId: ID) {
    media(where: { id: $mediaId }) {
      id
      name
      size
      fileType
      height
      width
      key
      url
      type
      createdAt
      org {
        id
        name
      }
      sharedWith {
        name
      }
      mediaNotes
      mediaHasNotes
    }
  }
`;

export default GET_ORG_MEDIA;
